import React from 'react';

const DoorOpenIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M7.3335 8.66406C7.60433 8.66406 7.8335 8.3724 7.8335 7.9974C7.8335 7.64323 7.60433 7.33073 7.3335 7.33073C7.04183 7.33073 6.8335 7.64323 6.8335 7.9974C6.8335 8.3724 7.04183 8.66406 7.3335 8.66406ZM14.3335 12.3307H12.0002V5.03906C12.0002 4.47656 11.5418 3.9974 11.0002 3.9974H9.3335V3.3724C9.3335 2.97656 9.021 2.66406 8.66683 2.66406C8.60433 2.66406 8.54183 2.6849 8.50016 2.70573L4.50016 3.72656C4.18766 3.8099 4.00016 4.08073 4.00016 4.39323V12.3307H1.66683C1.47933 12.3307 1.3335 12.4974 1.3335 12.6641V12.9974C1.3335 13.1849 1.47933 13.3307 1.66683 13.3307H14.3335C14.5002 13.3307 14.6668 13.1849 14.6668 12.9974V12.6641C14.6668 12.4974 14.5002 12.3307 14.3335 12.3307ZM8.3335 12.3307H5.00016V4.64323L8.3335 3.76823V12.3307ZM11.0002 12.3307H9.3335V4.9974H11.0002V12.3307Z"
        fill="#4E758E"
      />
    </svg>
  );
};

export default DoorOpenIcon;
